import { NEW_BOOKING } from './types'
import Cookies from 'js-cookie'

export const createBooking = (bookingData) => dispatch => {
  // console.debug('update redux and local storage', bookingData)
  
  // localStorage.setItem('booking', JSON.stringify(bookingData))
  Cookies.set('booking', JSON.stringify(bookingData), { expires: 1 });

  dispatch({
    type: NEW_BOOKING,
    payload: bookingData
  })
}